import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import OnboardingScreenVideo from "./pages/OnboardingScreenVideo";
import OnboardingCustom from "./pages/OnboardingCustom";
import ProductsScreen from "./pages/ProductSreen";
import CartScreen from "./pages/CartScreen";
import CartScreenVoucher from "./pages/CartScreenVoucher";
import ChoosePayment from "./pages/ChoosePaymentScreen";
import RegistrationScreen from "./pages/RegistrationScreen";
import QRCodeScreen from "./pages/QRCodeScreen";
import AccountScreen from "./pages/AccountScreen";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PaymentHistory from "./pages/PaymentHistory";
import ContactPage from "./pages/ContactPage";
import ChatPage from "./pages/ChatPage";
import EmailPage from "./pages/EmailPage";
import BankIdStart from "./pages/BankIdStart";
import BankIdComplete from "./pages/BankIdComplete";
import UnitsScreen from "./pages/UnitsScreen";
import BlockedPermanentlyPage from "./pages/BlockedPermanentlyPage";
import BlockedTemporaryPage from "./pages/BlockedTemporaryPage";
import SupportPage from "./pages/SupportPage";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import getTenantFromHost from "./services/utils/host";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});

function App() {
  // Decide which onboarding to render based on tenant derived from host
  const tenant = getTenantFromHost();
  if (typeof window !== "undefined") {
    window.__ziplinkTenant = tenant;
    // eslint-disable-next-line no-console
    console.info("[ziplink] tenant:", tenant, "host:", window.location.hostname);
  }
  const Onboarding = tenant === "boxmart" ? OnboardingCustom : OnboardingScreenVideo;

  return (
    <Router>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Onboarding />} />
            <Route path="/products" element={<ProtectedRoute element={ProductsScreen} />} />
            <Route path="/cart" element={<ProtectedRoute element={CartScreen} />} />
            <Route path="/cart-voucher" element={<ProtectedRoute element={CartScreenVoucher} />} />
            <Route path="/choose-payment" element={<ProtectedRoute element={ChoosePayment} />} />
            <Route path="/registration" element={<RegistrationScreen />} />
            <Route path="/qrcode" element={<ProtectedRoute element={QRCodeScreen} />} />
            <Route path="/account" element={<ProtectedRoute element={AccountScreen} />} />
            <Route path="/paymenthistory" element={<ProtectedRoute element={PaymentHistory} />} />
            <Route path="/contact" element={<ProtectedRoute element={ContactPage} />} />
            <Route path="/chat" element={<ProtectedRoute element={ChatPage} />} />
            <Route path="/support" element={<ProtectedRoute element={SupportPage} />} />
            <Route path="/email" element={<ProtectedRoute element={EmailPage} />} />
            <Route path="/bankid-start" element={<BankIdStart />} />
            <Route path="/bankid-complete" element={<BankIdComplete />} />
            <Route path="/units" element={<UnitsScreen />} />
            <Route path="/permanently-blocked" element={<BlockedPermanentlyPage />} />
            <Route path="/temporarily-blocked" element={<BlockedTemporaryPage />} />
          </Routes>
        </AuthProvider>
      </QueryClientProvider>
    </Router>
  );
}

export default App;
